
import { Prop, Vue, Component, Watch } from "vue-property-decorator";
import CardContainer from "@/components/CardContainer/index.vue";
import LineChart from "@/components/LineChart/index.vue";
import { moneyFormat } from "@/utils/util";
import {
  getWorkbenchCoreData,
  getWorkbenchCoreDataChart,
  getWorkbenchCoreDataShop2,
  getWorkbenchCoreDataChartShop2,
} from "@/api/shouyin";
import { Getter } from "vuex-class";

// 核心数据
@Component({
  components: { LineChart, CardContainer },
})
export class CoreData extends Vue {
  @Getter isMultiStore!: boolean;
  @Getter multiStoreList!: Array<any>;
  @Prop({ default: () => ({}) }) params!: any;
  isInit = false;
  empty = true;

  paramsLine = {
    lineName: "销售笔数", // 折线名称
    xData: [], // x轴数据
    yData: [], // y轴数据
  };

  listData = [
    {
      label: "销售笔数",
      value: "0",
      prop: "totalOrderCount",
      isMoney: false,
      color: "#FD8305",
    },
    {
      label: "实收金额",
      value: "0",
      prop: "totalSaleMoney",
      isMoney: true,
    },
    {
      label: "销售金额",
      value: "0",
      prop: "totalOrderMoney",
      isMoney: true,
    },
    {
      label: "退货金额",
      value: "0",
      prop: "totalReturnMoney",
      isMoney: true,
    },
  ];

  @Watch("params", { deep: true, immediate: true })
  onParamsChange() {
    this.getData();
  }

  async getTotalData() {
    let res: any;
    if (this.isMultiStore) {
      const params = {
        orderType: this.params.orderType,
        queryTimeBegin: this.params.queryTimeBegin,
        queryTimeEnd: this.params.queryTimeEnd,
        storeList: this.multiStoreList.map((item) => {
          return { storeId: item };
        }),
      };
      res = await getWorkbenchCoreDataShop2(params);
    } else {
      res = await getWorkbenchCoreData(this.params);
    }
    this.listData.forEach((item) => {
      const value = res.data[0]?.[item.prop] || "";
      if (item.isMoney) {
        const formatValue = `${moneyFormat(value, "")}`;
        item.value = formatValue === "--" ? "0.00" : formatValue;
      } else {
        item.value = value || "0";
      }
    });
  }
  async getChartData() {
    /**
     * storeId
    queryTimeBegin
    queryTimeEnd
    orderType
    queryType 1 24小时, 2 日期
     */
    const startTime = this.params.queryTimeBegin?.slice(0, 10) ?? "";
    const endTime = this.params.queryTimeEnd?.slice(0, 10) ?? "";
    let paramObj: any = {
      ...this.params,
      queryType: startTime === endTime ? 1 : 2,
    };
    let res: any;
    if (this.isMultiStore) {
      paramObj = {
        orderType: this.params.orderType,
        queryTimeBegin: this.params.queryTimeBegin,
        queryTimeEnd: this.params.queryTimeEnd,
        queryType: startTime === endTime ? 1 : 2,
        storeList: this.multiStoreList.map((item) => {
          return { storeId: item };
        }),
      };
      res = await getWorkbenchCoreDataChartShop2(paramObj);
    } else {
      res = await getWorkbenchCoreDataChart(paramObj);
    }
    const key = startTime === endTime ? "hour" : "date";
    this.paramsLine.xData = res.data.map((item: any) => item[key]);
    this.paramsLine.yData = res.data.map((item) => {
      return item.totalOrderCount;
    });
    this.empty = this.paramsLine.yData?.every((item) => Number(item) === 0);
  }
  async getData() {
    this.isInit = false;
    if (!this.params.storeId && !this.multiStoreList.length) {
      this.isInit = true;
      return;
    }
    await Promise.all([this.getTotalData(), this.getChartData()]);
    this.isInit = true;
  }
}
export default CoreData;
